import { SystemBanners } from "@portal/components/features/banner/SystemBanners";
import { MainLayout } from "@portal/components/layout/MainLayout";
import { ReactNode } from "react";
import { AdminMainNav } from "./AdminMainNav";

export const AdminMainLayout = (props: { children: ReactNode }) => (
	<MainLayout
		mainNav={<AdminMainNav />}
		topBanner={<SystemBanners className="flex flex-col gap-2 w-full px-6 py-4" />}
	>
		{props.children}
	</MainLayout>
);
